import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaLeaf, FaUmbrellaBeach, FaHandHoldingHeart } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ServicesContainer = styled.div`
  padding: 100px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
`;

const ServicesWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 30px;
  padding: 0 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const ServicesCard = styled(motion.div)`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const ServicesIcon = styled.div`
  height: 80px;
  width: 80px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #1A365D;
  color: #fff;
  font-size: 2.5rem;
`;

const ServicesH1 = styled.h2`
  font-size: 2.5rem;
  color: #1A365D;
  font-family: 'Playfair Display', serif;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const ServicesH2 = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 10px;
  font-family: 'Playfair Display', serif;
  color: #1A365D;
`;

const ServicesP = styled.p`
  font-size: 1rem;
  text-align: center;
  font-family: 'Open Sans', sans-serif;
  color: #333;
`;

const ServicesButton = styled(Link)`
  margin-top: 20px;
  border-radius: 4px;
  background: #4CAF50;
  white-space: nowrap;
  padding: 10px 22px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #1A365D;
  }
`;

const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 1px;
    background: #e0e0e0;
  }
`;

const Services = () => {
  return (
    <ServicesContainer id="services">
      <TitleWrapper>
        <ServicesH1>Nossos Serviços</ServicesH1>
      </TitleWrapper>
      <ServicesWrapper>
        <ServicesCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <ServicesIcon>
            <FaLeaf />
          </ServicesIcon>
          <ServicesH2>Cremação</ServicesH2>
          <ServicesP>
            Um dos mais modernos sistemas do Brasil para o processo de cremação, com respeito e dignidade.
          </ServicesP>
          <ServicesButton to="/cremacao">Saiba Mais</ServicesButton>
        </ServicesCard>
        <ServicesCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <ServicesIcon>
            <FaUmbrellaBeach />
          </ServicesIcon>
          <ServicesH2>Cemitérios</ServicesH2>
          <ServicesP>
            Diversas opções de cemitérios, incluindo Jardim, Convencional, Galeria com Gavetas e mais.
          </ServicesP>
          <ServicesButton to="/cemiterios">Saiba Mais</ServicesButton>
        </ServicesCard>
        <ServicesCard
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <ServicesIcon>
            <FaHandHoldingHeart />
          </ServicesIcon>
          <ServicesH2>Planos</ServicesH2>
          <ServicesP>
            Planos de serviços com pagamentos facilitados para sua tranquilidade e comodidade.
          </ServicesP>
          <ServicesButton to="/planos">Saiba Mais</ServicesButton>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
